// Module
var code = `<div ng-if="reportController.report.allowed === false" class="report"> <pdf-button ng-click="reportController.exportAsPdf()" ng-if="reportController.exportable !== 'false'" view-classes="'btn-sm'"> </pdf-button> <div class="alert alert-warning m-t-10 m-b-0" translate="Page.Report.Info.NotAllowed"> You are not allowed to view this report. </div> </div> <div ng-if="reportController.report.allowed === true" class="report"> <div class="customer-title m-b-15"> <div ng-if="reportController.report.subReports.length === 0"> <h1 class="color--env_base_bg"> {{ reportController.report.evaluation.code }} {{ reportController.report.evaluation.names | description }} </h1> <strong>{{ 'Page.Evaluation.Report.Period' | translate }}: {{ reportController.report.evaluation.period.period }} - {{ reportController.report.evaluation.period.displayYear }}</strong> <p>{{ reportController.report.template.names | description }}</p> </div> <div class="p-b-25" ng-if="reportController.report.subReports.length > 0"> <h1 class="p-b-25"> {{ reportController.report.template.names | description }} </h1> </div> <div class="visible-md visible-lg hidden-print pull-left"> <button ng-if="reportController.cardsView" class="btn btn-sm btn-default" type="button" ng-click="reportController.toggleNavSidebar()"> <i class="fa fa-bars"></i> </button> </div> <div class="hidden-print pull-right"> <button class="btn btn-sm btn-default" ng-click="reportController.exportAsExcel()"> <i class="fa fa-file-excel-o"></i> <span translate="Generic.Excel">Excel report</span> </button> <pdf-button ng-click="reportController.exportAsPdf()" ng-if="reportController.exportable !== 'false'" view-classes="'btn-sm'"> </pdf-button> </div> <div class="clearfix"></div> </div> <div class="d-f gap-40"> <aside ng-show="reportController.navSidebarOpen !== false" class="visible-md visible-lg m-b-15 p-l-10 flex-shrink-0" style="width: 26.66%"> <nav class="nav--sidebar nav--sidebar--sticky" id="nav--sidebar" aria-role="navigation"> <ul class="nav nav-pills nav-stacked mocked-te-theme"> <li ng-repeat="section in reportController.sections track by \$index" class="uib-tab" data-section-id-nav="{{ section.sectionId }}"> <a ng-click="reportController.scrollTo(section.sectionId)"> <div class="nav--sidebar--item--label"> {{ section.sectionLabel }} </div> </a> </li> </ul> </nav> </aside> <main class="flex-1 m-b-10"> <section ng-if="reportController.report.subReports.length > 0" ng-include="'component--evaluations.html'" data-section-id="evaluations" aria-label="{{ 'Generic.Evaluations' | translate }}" class="m-t-10"></section> <div ng-if="reportController.report.draft === true" class="alert alert-warning m-b-10"> <i class="fa fa-lightbulb-o m-r-5"></i> <strong translate="Page.Evaluation.Report.Draft"> This report is still in draft, the results can change over time. </strong> </div> <div ng-if="reportController.report.available === false" class="alert alert-info m-b-10" translate="Page.Report.Info.NotEnoughRespondents"> Not enough respondents. </div> <section ng-if="reportController.report.tags.length > 0" ng-include="'component--tags.html'"></section> <div class="m-t-10" ng-if="reportController.report.template.reportType === 'PARTICIPANT_REPORT'"> <participant-select label="Page.Report.Participants" evaluation-id="reportController.report.evaluation.id" auto-select="reportController.autoSelectParticipant !== false" ng-model="reportController.filters.id" ng-change="reportController.onRefresh()"> </participant-select> </div> <section ng-if="!reportController.report.template.showFeedbackLast && reportController.report.feedbacks.length > 0" ng-include="'component--feedbacks.html'" data-section-id="feedbacks" aria-label="{{ 'Page.Evaluation.Report.Feedback' | translate }}" class="m-t-10 m-b-15"></section> <div class="m-t-10" data-section-id="summary" aria-label="{{ 'Page.Evaluation.Report.Summary' | translate }}"> <report-summary summary="reportController.summary" report="reportController.report"> </report-summary> </div> <div ng-if="reportController.report.available === true"> <i translate="Page.Report.Info.RespondentsVary"></i> <div ng-include="'component--question--filters.html'"></div> <div ng-repeat="grouped in reportController.groupedBlocks track by \$index" ng-if="grouped.blocks.length > 0"> <div ng-include="'component--closed.html'" ng-init="blocks = grouped.blocks" ng-if="!grouped.open"></div> <div ng-include="'component--open.html'" ng-init="blocks = grouped.blocks;" ng-if="grouped.open"></div> </div> </div> <section ng-if="reportController.report.members.length > 0" ng-include="'component--members.html'" data-section-id="members" aria-label="{{ 'Page.Evaluation.Members' | translate }}"></section> <section ng-if="reportController.report.template.showFeedbackLast && reportController.report.feedbacks.length > 0" ng-include="'component--feedbacks.html'" data-section-id="feedbacks" aria-label="{{ 'Page.Evaluation.Report.Feedback' | translate }}" class="m-t-10 m-b-15"></section> <dice-credits></dice-credits> </main> </div> </div> ${"<" + "script"} type="text/ng-template" id="component--question--filters.html"> <section class="row">
    <div class="col-md-12">
      <table class="table table-condensed table-striped">
        <tbody ng-repeat="block in reportController.report.reportBlocks track by \$index">
          <tr
            ng-repeat="question in block.questionReports | filter: reportController.isVisible | orderBy : 'sequence'"
            data-section-id="{{ \$parent.\$first && \$first ? 'filters' : '' }}"
            aria-label="{{ \$parent.\$first && \$first ? ('Page.Evaluation.Report.Filters' | translate) : '' }}"
            class="table-fit-first-column">
            <td>
              <span
                ng-click="reportController.removeQuestion(question)"
                class="label label-rounded label-success hidden-print">
                <i class="fa fa-times"></i>
              </span>
              <span>{{ reportController.indexPerBlock ? question.indexInBlock + 1 : question.index }}.</span>
              <span ng-bind-html="question.questionLabel"></span>
            </td>

            <td>
              <span ng-repeat="option in question.options | orderBy : 'sequence'" ng-if="option.count > 0 || option.active === true">
                <span
                  ng-if="option.count > reportController.report.template.minimumRespondents"
                  ng-click="reportController.toggleAnswer(option, question)"
                  class="label label-success m-r-5"
                  ng-class="{ 'active' : option.active }">
                  <span>{{ option.label }}: {{ option.count }} ({{ option.percentage | number : 0 }}%)</span>
                  <i class="fa fa-times" ng-if="option.active"></i>
                </span>
                <span
                  ng-if="option.count <= reportController.report.template.minimumRespondents"
                  class="label label-success m-r-5 label-outline"
                  uib-tooltip="{{ 'Page.Report.Info.NotEnoughRespondents' | translate }}"
                  tooltip-append-to-body="true"
                  tooltip-position="bottom">
                  <span>{{ option.label }}: {{ option.count }} ({{ option.percentage | number : 0 }}%)</span>
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--tags.html"> <div class="row">
    <div class="col-md-12">
      <table class="table table-condensed table-striped m-t-15 m-b-5">
        <tbody>
          <tr class="table-fit-first-column" ng-repeat="tag in reportController.report.tags | orderBy : 'sequence'">
            <td><strong>{{ tag.name }}</strong></td>

            <td>
              <span ng-repeat="tagGroup in tag.groups track by tagGroup.name | orderBy : 'participantCount': true">
                <span
                  class="label label-success m-r-5"
                  ng-class="{ 'active' : tagGroup.active }"
                  ng-if="tagGroup.respondentCount > reportController.report.template.minimumRespondents"
                  ng-include="'component--tag.html'"
                  ng-click="reportController.toggleTag(tag, tagGroup)"
                  uib-tooltip="{{ 'Page.Evaluation.Report.Response' | translate }}: {{ tagGroup.respondentCount }} / {{ tagGroup.participantCount }} ({{ tagGroup.respondentPercentage | number : 0 }}%)"
                  tooltip-append-to-body="true"
                  tooltip-position="bottom">
                </span>
                <span
                  class="label label-success m-r-5 label-outline"
                  ng-if="tagGroup.respondentCount <= reportController.report.template.minimumRespondents"
                  ng-include="'component--tag.html'"
                  uib-tooltip="{{ 'Page.Report.Info.NotEnoughRespondents' | translate }}"
                  tooltip-append-to-body="true"
                  tooltip-position="bottom">
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--tag.html"> {{ tagGroup.name }}: {{ tagGroup.respondentCount }} ({{ tagGroup.percentage | number : 0 }}%) <i class="fa fa-times" ng-if="tagGroup.active"></i> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--feedbacks.html"> <div class="row">
    <div class="col-xs-12">
      <div ng-repeat="feedback in reportController.report.feedbacks">
        <report-feedback
          feedback="feedback"
          is-read-only="!reportController.feedbackEditable"
          evaluation="reportController.report.evaluation"
          participant-id="reportController.filters.id"
          on-change="reportController.onRefresh()">
        </report-feedback>
      </div>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--closed.html"> <div class="row">
    <div class="col-md-12">
      <div ng-if="reportController.cardsView">
        <section
          ng-repeat="block in blocks track by \$index"
          data-section-id="{{ block.htmlId }}"
          aria-label="{{ block.blockLabel }}"
          class="panel panel-default">
          <div class="panel-heading" ng-if="reportController.report.template.showBlocks">
            <report-heading
              member="block.member"
              block-label="{{ block.blockLabel }}"
              class="i-b">
            </report-heading>
          </div>

          <div class="panel-body">
            <table class="table table-condensed valign-middle">
              <tbody>
                <tr
                  ng-repeat-start="question in block.questionReports track by \$index"
                  ng-if="question.includeTableHeader"
                  ng-include="'header--' + question.visualization + '.html'"
                  class="report-thead">
                </tr>
                <tr
                  ng-repeat-end
                  ng-include="'contents--' + question.visualization + '.html'">
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <div ng-if="!reportController.cardsView">
        <div class="table-responsive">
          <table class="table table-condensed table-striped valign-middle">
            <colgroup>
              <col width="65%" />
            </colgroup>

            <tbody ng-repeat="block in blocks track by \$index">
              <tr
                ng-if="reportController.report.template.showBlocks"
                class="uses-default-options">
                <td colspan="{{ reportController.tableColspan + 4 }}" ng-class="{ 'm-b-10': block.member }">
                  <report-heading
                    member="block.member"
                    block-label="{{ block.blockLabel }}"
                    class="i-b">
                  </report-heading>
                </td>
              </tr>

              <tr
                ng-repeat-start="question in block.questionReports track by \$index"
                ng-if="question.includeTableHeader"
                ng-include="'header--' + question.visualization + '.html'"
                class="report-thead">
              </tr>
              <tr
                ng-repeat-end
                ng-include="'contents--' + question.visualization + '.html'">
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--open.html"> <div class="row">
    <div class="col-sm-12">
      <div ng-if="reportController.cardsView">
        <section
          ng-repeat="block in blocks track by \$index"
          data-section-id="{{ block.htmlId }}"
          aria-label="{{ block.blockLabel }}"
          class="panel panel-default">
          <div
            ng-if="reportController.report.template.showBlocks"
            class="panel-heading">
            <report-heading
              block-label="{{ block.blockLabel }}">
            </report-heading>
          </div>

          <div
            class="panel-body"
            ng-include="'components--open__table.html'">
          </div>
        </section>
      </div>

      <div ng-if="!reportController.cardsView">
        <div class="row">
          <div class="col-sm-12">
            <h4>
              <strong translate="Page.Evaluation.Report.OpenQuestions">Open questions </strong>
            </h4>
          </div>
        </div>

        <div class="row">
          <div
            ng-repeat-start="block in blocks track by \$index"
            ng-if="block.member.index === 1"
            class="col-sm-12">
            <h4>
              <strong>{{ block.blockLabel }}</strong>
            </h4>
          </div>

          <div
            ng-class="{'col-sm-6 col-p-6': block.member.index, 'col-sm-12': !block.index}"
            ng-include="'components--open__table.html'">
          </div>

          <div
            ng-if="block.member.index"
            ng-class="{'clearfix visible-xs-block visible-sm-block visible-md-block visible-lg-block': block.member.index % 2 === 0}"
            ng-repeat-end>
          </div>
        </div>
      </div>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="components--open__table.html"> <table class="table table-striped">
    <thead ng-if="reportController.report.template.showBlocks">
      <tr ng-if="block.member">
        <th>
          <report-heading
            member="block.member"
            class="i-b">
          </report-heading>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        ng-repeat-start="question in block.questionReports track by \$index"
        ng-if="question.includeTableHeader"
        ng-include="'header--' + question.visualization + '.html'"
        class="report-thead">
      </tr>

      <tr
        ng-repeat-end
        ng-include="'contents--' + question.visualization + '.html'">
      </tr>
    </tbody>
  </table> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--members.html"> <div class="row m-t-20">
    <div ng-if="\$even && !\$first" ng-repeat-start="wrapper in reportController.report.members" class="clearfix hidden-xs-block"></div>
    <div class="col-md-6" ng-repeat-end>
      <div class="table-responsive">
        <table class="table table-condensed table-striped">
          <thead class="report-thead">
            <tr>
              <th>{{ wrapper.type }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-fit-first-column">
              <td>
                <ul class="list-unstyled m-b-0">
                  <li ng-if="wrapper.empty === true">-</li>
                  <li ng-repeat="(name, email) in wrapper.members">{{name}} <strong ng-if="email">({{email}})</strong></li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="component--evaluations.html"> <div class="row">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-condensed table-striped valign-middle m-b-0">
          <thead class="report-thead">
            <tr class="table-rotate-header">
              <th translate="Generic.Evaluations">Evaluations</th>
              <th translate="Page.Evaluation.Report.Period">Period</th>
              <th translate="Page.CondensedReport.EvaluationParticipants">Number of attendees</th>
              <th><span translate>Response</span> (%)</th>
              <th><span translate>Total</span> (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="subReport in reportController.report.subReports">
              <td>
                <span ng-if="reportController.report.layout === 'COMPARED_TO_SUM'">
                  <i ng-if="\$first" class="fa fa-eye fa-fw"></i>
                  <i ng-if="!\$first" class="fa fa-balance-scale fa-fw clickable" ng-click="reportController.focus(subReport)"></i>
                </span> {{ \$index + 1 }}. {{ subReport.evaluation.code }} {{ subReport.evaluation.names | description }}
              </td>
              <td>{{ subReport.evaluation.period.period }} - {{ subReport.evaluation.period.displayYear }}</td>
              <td>{{ subReport.reportCourse.participantCount }}</td>
              <td>{{ subReport.reportCourse.respondentCount }} ({{ subReport.reportCourse.respondentPercentage | number : 0 }}%)</td>
              <td><span ng-if="reportController.report.reportCourse.respondentCount !== 0">{{ ((subReport.reportCourse.respondentCount / reportController.report.reportCourse.respondentCount) * 100) | number : 2 }}%</span>
                <span ng-if="reportController.report.reportCourse.respondentCount === 0">0%</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="header--TABLE.html"> <th translate="Page.Evaluation.Report.OpinionsTitle">Opinions on the course</th>
  <th class="fixed-width" ng-repeat="header in reportController.report.headers | orderBy : 'sequence'">
    {{ (header.labels | description) || header.values.join(', ') }}
  </th>
  <th></th>
  <th class="th-sm" translate="Page.Evaluation.Report.StandardDeviation">Dev.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.Median">Med.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.Avg">Avg.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.NrResp">Nr. resp</th> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="contents--TABLE.html"> <td>
    <span
      ng-if="!reportController.isVisible(question) && question.questionTemplateId !== undefined && !block.member"
      ng-click="reportController.addQuestion(question)"
      class="label label-rounded label-success hidden-print">
      <i class="fa fa-plus"></i>
    </span>
    <span>{{ reportController.indexPerBlock ? question.indexInBlock + 1 : question.index }}.</span>
    <span ng-bind-html="question.questionLabel"></span>
  </td>
  <td class="fixed-width nowrap"
      ng-style="{ 'color': column.thresholdColor }"
      ng-repeat="column in question.columns">
    <span ng-if="column.averageValue > 0">{{ column.averageValue | number : 1 }} (</span>
    <span>{{ column.count }}</span>
    <span ng-if="column.averageValue > 0">)</span>
    <span ng-if="column.percentage > 0">({{ column.percentage | number : 0 }}%)</span>
    <i class="fa fa-asterisk text-superscript" ng-show="column.thresholdColor"></i>
  </td>
  <td></td>
  <td>
    <span ng-show="question.calculate">{{ question.standardDeviationValue | number : 1 }}</span>
  </td>
  <td>
    <span ng-show="question.calculate">{{ question.medianValue | number : 1 }}</span>
  </td>
  <td ng-style="{ 'color': question.thresholdColor }">
    <span ng-show="question.calculate">
      {{ question.averageValue | number : 1 }}
      <dice-benchmark-label
        question="question"
        benchmark="question.benchmark">
      </dice-benchmark-label>
      <dice-benchmark-label
        question="question"
        benchmark="question.benchmarkFilter"
        tooltip="Page.Report.Benchmarks.FilterTooltip">
      </dice-benchmark-label>
    </span>
  </td>
  <td>
    <span>{{ question.respondentCount }}</span>
    <i
      class="fa fa-info-circle"
      tooltip-placement="left"
      uib-tooltip="{{ 'Page.Report.Info.RespondentsVary' | translate }}"
      ng-if="reportController.report.reportCourse.respondentCount > question.respondentCount">
    </i>
  </td> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="header--GRAPH.html"> <th colspan="{{ reportController.tableColspan + 1 }}" translate="Page.Evaluation.Report.OpinionsTitle">Opinions on the course</th>
  <th class="th-sm" translate="Page.Evaluation.Report.Median">Med.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.Avg">Avg.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.NrResp">Nr. resp</th> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="contents--GRAPH.html"> <td colspan="{{ reportController.tableColspan + 1 }}" class="options-title" style="table-layout: fixed; page-break-inside: auto">
    <div class="row">
      <div class="col-xs-6">
        <span
          ng-if="!reportController.isVisible(question) && question.questionTemplateId !== undefined && !block.member"
          ng-click="reportController.addQuestion(question)"
          class="label label-rounded label-success hidden-print">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ reportController.indexPerBlock ? question.indexInBlock + 1 : question.index }}.</span>
        <span ng-bind-html="question.questionLabel"></span>
      </div>

      <div class="col-xs-6">
        <div
          ng-repeat="option in question.options | orderBy : 'sequence' track by \$index"
          class="row"
          ng-class="{ 'm-b-5': !\$last }"
          uib-tooltip="{{ option.label }}: {{ option.count }} ({{ option.percentage | number : 0 }}%)"
          tooltip-placement="top"
          style="page-break-inside: avoid; page-break-after: auto">
          <div class="col-xs-8">
            <strong
              ng-if="reportController.report.template.showEmptyOptions || option.count > 0"
              class="d-b truncate text-right"
              style="text-overflow: ellipsis">
              {{ option.label }}
            </strong>
          </div>

          <div class="col-xs-4 options-title">
            <div ng-show="option.count === 0 && reportController.report.template.showEmptyOptions">0</div>
            <div ng-show="option.count > 0" class="progress">
              <div class="progress-bar progress-bar--customer" role="progressbar" ng-style="{ 'width': option.percentage + '%'}"></div>
              <span class="progress-bar-text" ng-style="{ 'color': option.thresholdColor }">
                {{ option.count }} ({{ option.percentage | number : 0 }}%)
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </td>
  <td>
    <span ng-show="question.calculate">{{ question.medianValue | number : 1 }}</span>
  </td>
  <td ng-style="{ 'color': question.thresholdColor }">
    <span ng-show="question.calculate">
      {{ question.averageValue | number : 1 }}
      <dice-benchmark-label
        question="question"
        benchmark="question.benchmark">
      </dice-benchmark-label>
      <dice-benchmark-label
        question="question"
        benchmark="question.benchmarkFilter"
        tooltip="Page.Report.Benchmarks.FilterTooltip">
      </dice-benchmark-label>
    </span>
  </td>
  <td>
    <span>{{ question.respondentCount }}</span>
    <i
      class="fa fa-info-circle"
      tooltip-placement="left"
      uib-tooltip="{{ 'Page.Report.Info.RespondentsVary' | translate }}"
      ng-if="reportController.report.reportCourse.respondentCount > question.respondentCount">
    </i>
  </td> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="header--HISTOGRAM.html"> <th colspan="{{ reportController.tableColspan }}" translate="Page.Evaluation.Report.OpinionsTitle">Opinions on the course</th>
  <th class="th-sm" translate="Page.Evaluation.Report.StandardDeviation">Dev.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.Median">Med.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.Avg">Avg.</th>
  <th class="th-sm" translate="Page.Evaluation.Report.NrResp">Nr. resp</th> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="contents--HISTOGRAM.html"> <td colspan="{{ reportController.questionColspan }}" ng-style="{ 'position': 'relative' }">
    <span
      ng-if="!reportController.isVisible(question) && question.questionTemplateId !== undefined && !block.member"
      class="label label-rounded label-success hidden-print"
      ng-click="reportController.addQuestion(question)">
      <i class="fa fa-plus"></i>
    </span>
    <span>{{ reportController.indexPerBlock ? question.indexInBlock + 1 : question.index }}.</span>
    <span ng-bind-html="question.questionLabel"></span>
  </td>

  <td colspan="{{ reportController.remainderColspan }}">
    <dice-report-histogram
      question="question">
    </dice-report-histogram>
  </td>
  <td>
    <span ng-show="question.calculate">{{ question.standardDeviationValue | number : 1 }}</span>
  </td>
  <td>
    <span ng-show="question.calculate">{{ question.medianValue | number : 1 }}</span>
  </td>
  <td ng-style="{ 'color': question.thresholdColor }">
    <span ng-show="question.calculate">
      {{ question.averageValue | number : 1 }}
      <dice-benchmark-label
        question="question"
        benchmark="question.benchmark">
      </dice-benchmark-label>
      <dice-benchmark-label
        question="question"
        benchmark="question.benchmarkFilter"
        tooltip="Page.Report.Benchmarks.FilterTooltip">
      </dice-benchmark-label>
    </span>
  </td>
  <td>
    <span>{{ question.respondentCount }}</span>
    <i
      class="fa fa-info-circle"
      tooltip-placement="left"
      uib-tooltip="{{ 'Page.Report.Info.RespondentsVary' | translate }}"
      ng-if="reportController.report.reportCourse.respondentCount > question.respondentCount">
    </i>
  </td> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="contents--BULLET.html"> <td
    ng-class="{
      'p-0 p-t-20': reportController.cardsView && question.indexInBlock !== 0,
      'p-0 border--none--i': reportController.cardsView && question.indexInBlock === 0
    }">
    <div
      ng-class="{ 'panel panel-default panel--secondary': reportController.cardsView }">
      <div
        class="text-bold"
        ng-class="{ 'panel-heading': reportController.cardsView }"
        ng-bind-html="question.questionLabel">
      </div>

      <div ng-class="{ 'panel-body': reportController.cardsView }">
        <ul class="list-style-square list-no-indent">
          <li ng-repeat="option in question.options | orderBy : ['label'] track by option.value"
              ng-if="option.count > 0">
            <span ng-show="option.count > 1" class="badge">{{ option.count }} </span>
            <span class="text--capitalize-first-letter">{{ option.label }}</span>
          </li>
        </ul>
      </div>
    </div>
  </td> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="contents--TEXT.html"> <td
    colspan="{{ reportController.tableColspan + 4 }}"
    class="options-title"
    ng-class="{
      'p-0 p-t-20': reportController.cardsView && question.indexInBlock !== 0,
      'p-0 border--none--i': reportController.cardsView && question.indexInBlock === 0
    }"
    style="table-layout: fixed; page-break-inside: auto">

    <div ng-class="{ 'panel panel-default panel--secondary': reportController.cardsView }">
      <div
        class="text-bold"
        ng-class="{ 'panel-heading': reportController.cardsView }"
        ng-bind-html="question.questionLabel">
      </div>

      <div ng-class="{ 'panel-body': reportController.cardsView }">
        <span
          ng-repeat="option in question.options | orderBy : ['label'] track by option.value"
          ng-if="option.count > 0">
          <span ng-show="option.count > 1" class="badge">{{ option.count }} </span>
          <span class="text--capitalize-first-letter">{{ option.label }}</span>
        </span>
      </div>
    </div>
  </td> ${"<" + "/script"}> `;
// Exports
module.exports = code;